import { register, ColorList, TypeList } from 'react-easy-styleguide';

register(
  ColorList({
    primary: 'bg-primary',
    success: 'bg-success',
    info: 'bg-info',
    warning: 'bg-warning',
    danger: 'bg-danger'
  })
)


register(
  TypeList({
    'Bootstrap h1': 'h1',
    'Bootstrap h2': 'h2',
    'Bootstrap h3': 'h3',
    'Bootstrap h4': 'h4',
    'Bootstrap h5': 'h5',
    'Bootstrap h6': 'h6',
    'Lead body copy': 'lead',
    'Small text': 'small'
  })
)
